import { fetchApi } from './api'

export const CREATE_WEBSOCKET = 'CREATE_WEBSOCKET'
export const CREATE_WEBSOCKET_ID = 'CREATE_WEBSOCKET_ID'
export const CHANGE_CHAT_STATUS = 'CHANGE_CHAT_STATUS'
export const ADD_MESSAGE = 'ADD_MESSAGE'
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE'
export const DELETE_MESSAGE = 'DELETE_MESSAGE'
export const GET_HISTORY_MESSAGE = 'GET_HISTORY_MESSAGE'
export const FETCH_GALLERY_IMAGE = 'FETCH_GALLERY_IMAGE'
export const FETCH_GALLERY_IMAGE_SUCCESS = 'FETCH_GALLERY_IMAGE_SUCCESS'
export const FETCH_GALLERY_IMAGE_ERROR = 'FETCH_GALLERY_IMAGE_ERROR'
export const GET_GROUP_LIST = 'GET_GROUP_LIST'
export const FETCH_GROUP_GUESTS = 'FETCH_GROUP_GUESTS'
export const FETCH_GROUP_GUESTS_SUCCESS = 'FETCH_GROUP_GUESTS_SUCCESS'
export const FETCH_GROUP_GUESTS_ERROR = 'FETCH_GROUP_GUESTS_ERROR'

export function createSocketId(socketId) {
  return {
    type: CREATE_WEBSOCKET_ID,
    socketId
  }
}

export function createWebSocket(socket) {
  return {
    type: CREATE_WEBSOCKET,
    socket
  }
}

export function changeChatStatus(status) {
  return {
    type: CHANGE_CHAT_STATUS,
    status
  }
}

export function getHistoryMessage(messageList) {
  return {
    type: GET_HISTORY_MESSAGE,
    messageList
  }
}

export function addMessage(message) {
  return {
    type: ADD_MESSAGE,
    message
  }
}

export function updateMessage(message) {
  return {
    type: UPDATE_MESSAGE,
    message
  }
}

export function getGroupList(groupList) {
  return {
    type: GET_GROUP_LIST,
    groupList
  }
}

export function deleteMessage(message) {
  return {
    type: DELETE_MESSAGE,
    message
  }
}

export function fetchGalleryImage({ galleryId, onSuccessCallback }) {
  return fetchApi({
    requestType: FETCH_GALLERY_IMAGE,
    successType: FETCH_GALLERY_IMAGE_SUCCESS,
    errorType: FETCH_GALLERY_IMAGE_ERROR,
    route: '/graphql2',
    options: {
      method: 'POST',
      body: JSON.stringify({
        query: `{
          galleries (ids: ["${galleryId}"]) {
            destroyed_at
            gallery_image_uploads {
              gallery_id
              id
              image_upload_id 
              sort_order
              image_upload {
                id
                large_url
                medium_url
                medium_cropped_url
                metadata {
                  dominant_color
                  width
                  height
                }
                state
                thumbnail_url
                upload_url
              }
            }
            id
            inserted_at
            updated_at
            user_id
          }
        }`
      })
    },
    onSuccessCallback
  })
}

export function fetchGroupGuests({ groupId, onSuccessCallback }) {
  return fetchApi({
    requestType: FETCH_GROUP_GUESTS,
    successType: FETCH_GROUP_GUESTS_SUCCESS,
    errorType: FETCH_GROUP_GUESTS_ERROR,
    route: `/graphql`,
    options: {
      method: 'POST',
      body: JSON.stringify({
        query: `{
          groups(ids: ["${groupId}"]) {
            channel
            destroyed_at
            external_room_id
            ... on NamedGroup {
              avatar {
                large_url_2x
                medium_url_2x
              }
              avatar_state
              name
            }
            ... on MemberDefinedGroup {
              name
            }
            group_members {
              destroyed_at
              id
              user {
                app_user
                verified
                id
                first_name
                last_name
              }
            }
            id
            type
           }
        }`
      })
    },
    onSuccessCallback
  })
}
